<form [formGroup]="form">
  <div class="row">
    <div class="form-group col">
      <label tcc-labelForNext>Organization</label>
      <select formControlName="org" class="form-select" [class.is-invalid]="fc.org.errors">
        <option [ngValue]="undefined">-- Select one --</option>
        @for (x of orgs$ | async; track x) {
          <option [ngValue]="x.orgCode">{{x.name}}</option>
        }
        @if (fc.org.errors) {
          <div class="invalid-feedback">
            @if (fc.org.errors.required) {
              <div>Organization is required</div>
            }
          </div>
        }
      </select>
    </div>
    <div class="form-group col">
      <label tcc-labelForNext>Name</label>
      <input formControlName="name" type="text" class="form-control" placeholder="Your name"
        [class.is-invalid]="fc.name.errors" />
        @if (fc.name.errors) {
          <div class="invalid-feedback">
            @if (fc.name.errors.required) {
              <div>Name is required</div>
            }
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="form-group col">
        <label tcc-labelForNext>Title</label>
        <input formControlName="title" type="text" class="form-control" placeholder="Your Title"
          [class.is-invalid]="fc.title.errors" />
          @if (fc.title.errors) {
            <div class="invalid-feedback">
              @if (fc.title.errors.required) {
                <div>Title is required</div>
              }
            </div>
          }
        </div>
        <div class="form-group col">
          <label tcc-labelForNext>Telephone</label>
          <input formControlName="phone" type="tel" class="form-control" placeholder="Enter phone in format (###) ###-####"
            [class.is-invalid]="fc.phone.errors" />
            <small class="form-text text-muted">
              Enter phone in format (###) ###-#### ext. #### (The extension is optional).
            </small>
            @if (fc.phone.errors) {
              <div class="invalid-feedback">
                @if (fc.phone.errors.required) {
                  <div>Phone is required</div>
                }
                @if (fc.phone.errors.pattern) {
                  <div>Phone must be in a valid format.</div>
                }
              </div>
            }
          </div>
        </div>
      </form>
